export default __webpack_public_path__ + "static/media/BusinessService.b17611b1.webp";